import css from 'styled-jsx/css';
import { colors, fonts, screen } from 'components/styles/variables';
import paperPlane from 'public/static/images/paper-plane.svg';
import greenCircle from 'public/static/images/check-green-circle.svg';
import smsIcon from 'public/static/images/red-sms-icon.svg';
import callIcon from 'public/static/images/call-icon.svg';

import back from 'public/static/images/vdp/back.svg';

export const formStyles = css.resolve`
  .form {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

export const modalFormStyles = css.resolve`
  .form {
    display: flex;
    flex-direction: column;
    height: fit-content;
    overflow: scroll;
  }

  @media (max-width: ${screen.smMax}) {
    .form {
      height: 100%;
    }
  }

  @media (min-width: ${screen.smMin}) {
    .form {
      overflow: visible;
    }
  }
`;

export const titleStyles = css`
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 29px;
  }

  .sms-variant-title {
    margin-bottom: 12px;
  }

  @media (min-width: ${screen.smMin}) {
    .title {
      margin-bottom: 44px;
    }
  }

  .lead-form-title {
    position: sticky;
    top: 0;
    z-index: 2;
    background: ${colors.WHITE};
    padding: 14px 16px 14px 16px;
    border-bottom: 1px solid ${colors.G2};
  }

  @media (min-width: ${screen.smMin}) {
    .lead-form-title {
      margin-bottom: 47px;
      padding: 0px 16px 0px 16px;
      border-bottom: none;
    }
  }

  @media (min-width: ${screen.smMin}) {
    .title.contacted {
      margin-bottom: 31px;
    }
  }

  .sub-text {
    font-size: 14px;
    color: ${colors.G3};
  }

  @media (min-width: ${screen.smMin}) {
    .sub-text {
      font-size: 16px;
    }
  }

  .text {
    margin: 0;
    letter-spacing: 0.2px;
    font-size: 24px;
    font-weight: 700;
  }

  @media (min-width: ${screen.smMin}) {
    .text {
      font-size: 30px;
    }
  }

  .plane {
    width: 28px;
    height: 28px;
    background-image: url(${paperPlane});
    background-size: cover;
  }

  @media (min-width: ${screen.smMin}) {
    .plane {
      width: 34px;
      height: 34px;
    }
  }

  .contacted-check {
    display: flex;
    align-self: flex-start;
    width: 38px;
    height: 38px;
    background-image: url(${greenCircle});
    background-size: contain;
    background-repeat: no-repeat;
  }

  @media (min-width: ${screen.smMin}) {
    .contacted-check {
      width: 44px;
      height: 44px;
    }
  }
`;

export const smsButtonStyles = css`
  .sms-icon {
    width: 28px;
    height: 28px;
    background-image: url(${smsIcon});
    background-size: cover;
    margin-right: 4px;
  }

  .call-icon {
    width: 28px;
    height: 28px;
    background-image: url(${callIcon});
    background-size: contain;
  }

  .contact-button-container {
    display: flex;
    gap: 16px;
  }

  .call-link {
    display: flex;
    color: ${colors.BLACK};
    text-align: center;
    font-family: ${fonts.default};
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.2px;
    gap: 4px;
  }

  .call-button,
  .sms-button {
    display: flex;
    flex: 1;
    height: 48px;
    padding: 10px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 1px solid ${colors.G2};
    background: ${colors.WHITE};
    color: ${colors.BLACK};
    text-align: center;
    font-family: ${fonts.default};
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.2px;
  }
`;

export default css`
  .lead-form {
    padding-top: 24px;
    box-sizing: border-box;
    background: ${colors.WHITE};
  }

  @media (min-width: ${screen.smMin}) {
    .lead-form {
      padding: 26px 32px 32px 32px;
      border: 1px solid ${colors.G2};
      box-shadow: 0px 13px 17px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      margin: 0 16px 0 16px;
      width: 100%;
    }
  }

  .padding {
    padding: 0px 16px;
  }

  .margin {
    margin: 0px 16px;
  }

  .submit-button-container {
    position: sticky;
    margin-top: auto;
    background: ${colors.WHITE};
    bottom: 0;
    width: 100%;
    height: 88px;
    padding: 16px;
    border-top: 1px solid ${colors.G2};
  }

  @media (min-width: ${screen.smMin}) {
    .submit-button-container {
      position: relative;
      border: none;
    }
  }

  .close-button {
    background-image: url(${back});
    background-size: cover;
    height: 19px;
    width: 14px;
    border: none;
    background-color: transparent;
    margin-right: 14.5px;
  }

  .flex-container {
    display: flex;
    align-items: center;
  }
`;
